<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Certificate Technical Approval</h5>
     <br/>

     <br>


     <div class="row">
      <div  class="form-group col-md-8" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Lab()" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>

     </div>

     <br>
     <br>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Certificate NO</th>
              <th>Instrument Name</th>
              <th>Instrument Code</th>
              <th>Instrument Serial Number</th>
              <th>Customer Name</th>
              <th>Receipt Number</th>
              <th>Calibration Location</th>
              <th>Calibration Technician</th>
              <th>Calibration Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Lab
            | paginate
                    : {
                        id: 'DataList_LabTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Lab).length
                      }
            ">
             <td>{{DataList_Lab.indexOf(item)+1}}</td>
             <td>{{item.certificateNO}}</td>
             <td>{{item.device_name}}</td>
              <td>{{item.device_code}}</td>
              <td>{{item.device_serial}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.code}}</td>
              <td>{{item.expert_Calibration}}</td>
              <td>{{item.expertName}}</td>
              <td>{{item.calibration_date}}</td>
              <td *ngIf="!item.Processing">
                <button  [routerLink]="[item.src,{id:item.id}]"  type="button" class="btn btn-success"><i class="fa fa-check"></i> Approve Certificate </button>
              </td>
              <td *ngIf="item.Processing">
                <img  src="assets/Loading.gif" style="width: 25px;" />
              </td>


            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_LabTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>
